/**
 * W11-L Statutory Configuration — Mock Fixture Data
 * PROTOTYPE ONLY — All data is static/mock. Not production statutory configuration.
 * Not legal evidence. Law 7/1999 rates and GCC treatment are NOT authoritative.
 */

export const MOCK_DISCLAIMER =
  "PROTOTYPE ONLY — All statutory data is mock/static fixture data. Not production statutory configuration. Not legal evidence.";

export const SCHEMA_HEAD = "0014_statutory_engine";
export const IMPL_AUTH_STATUS = "BLOCKED / NOT AUTHORIZED";

// ─── Jurisdictions ────────────────────────────────────────────────────────────

export const jurisdictions = [
  {
    id: "IN-EPFO",
    code: "IN-EPFO",
    name: "India — EPFO (Federal)",
    country: "IN",
    flag: "🇮🇳",
    regimeCodes: ["IN_EPF", "IN_ESI"],
    overallStatus: "DESIGN_READY",
    openOQs: 0,
  },
  {
    id: "AE-GPSSA",
    code: "AE-GPSSA",
    name: "UAE Federal — GPSSA",
    country: "AE",
    flag: "🇦🇪",
    regimeCodes: ["UAE_LAW_57_2023_GOV", "UAE_LAW_57_2023_PRIV", "UAE_LAW_7_1999", "GCC-SA", "GCC-BH", "GCC-KW", "GCC-QA", "GCC-OM"],
    overallStatus: "PARTIAL",
    openOQs: 7,
  },
  {
    id: "AE-ADPF",
    code: "AE-ADPF",
    name: "UAE — Abu Dhabi (ADPF)",
    country: "AE",
    flag: "🇦🇪",
    regimeCodes: ["AE_ADPF"],
    overallStatus: "BLOCKED",
    openOQs: 1,
  },
  {
    id: "AE-SHARJAH",
    code: "AE-SHARJAH",
    name: "UAE — Sharjah Government",
    country: "AE",
    flag: "🇦🇪",
    regimeCodes: ["AE_SHARJAH"],
    overallStatus: "BLOCKED",
    openOQs: 1,
  },
];

// ─── Regimes ──────────────────────────────────────────────────────────────────

export const regimes = [
  {
    code: "IN_EPF",
    name: "India EPF",
    jurisdiction: "IN-EPFO",
    legalInstrument: "EPF & MP Act 1952",
    legalSourceStatus: "PRIMARY_SOURCE_VERIFIED",
    interpretationStatus: "APPROVED_FOR_CONFIGURATION",
    counselStatus: "NOT_REQUIRED",
    classifierReadiness: "DESIGN_READY",
    eligibilityReadiness: "DESIGN_READY",
    calculationReadiness: "DESIGN_READY",
    uiReadiness: "PROTOTYPE_READY",
    activationStatus: "PENDING_ARB",
    blockingOQ: null,
  },
  {
    code: "IN_ESI",
    name: "India ESI",
    jurisdiction: "IN-EPFO",
    legalInstrument: "ESI Act 1948",
    legalSourceStatus: "PRIMARY_SOURCE_VERIFIED",
    interpretationStatus: "APPROVED_FOR_CONFIGURATION",
    counselStatus: "NOT_REQUIRED",
    classifierReadiness: "DESIGN_READY",
    eligibilityReadiness: "DESIGN_READY",
    calculationReadiness: "DESIGN_READY",
    uiReadiness: "PROTOTYPE_READY",
    activationStatus: "PENDING_ARB",
    blockingOQ: null,
    caveat: "GAP-05 noted",
  },
  {
    code: "UAE_LAW_57_2023_GOV",
    name: "UAE Law 57/2023 (Government)",
    jurisdiction: "AE-GPSSA",
    legalInstrument: "Federal Law No. 57 of 2023",
    legalSourceStatus: "PRIMARY_SOURCE_VERIFIED",
    interpretationStatus: "APPROVED_FOR_CONFIGURATION",
    counselStatus: "NOT_REQUIRED",
    classifierReadiness: "DESIGN_READY",
    eligibilityReadiness: "DESIGN_READY",
    calculationReadiness: "DESIGN_READY",
    uiReadiness: "PROTOTYPE_READY",
    activationStatus: "PENDING_ARB",
    blockingOQ: null,
  },
  {
    code: "UAE_LAW_57_2023_PRIV",
    name: "UAE Law 57/2023 (Private)",
    jurisdiction: "AE-GPSSA",
    legalInstrument: "Federal Law No. 57 of 2023 + Min. Decision No. 1/2024",
    legalSourceStatus: "PRIMARY_SOURCE_VERIFIED",
    interpretationStatus: "APPROVED_FOR_CONFIGURATION",
    counselStatus: "NOT_REQUIRED",
    classifierReadiness: "DESIGN_READY",
    eligibilityReadiness: "DESIGN_READY",
    calculationReadiness: "DESIGN_READY",
    uiReadiness: "PROTOTYPE_READY",
    activationStatus: "PENDING_ARB",
    blockingOQ: null,
  },
  {
    code: "UAE_LAW_7_1999",
    name: "UAE Law 7/1999 (Legacy)",
    jurisdiction: "AE-GPSSA",
    legalInstrument: "Federal Law No. 7 of 1999",
    legalSourceStatus: "SOURCE_IDENTIFIED",
    interpretationStatus: "LEGAL_INTERPRETATION_REQUIRED",
    counselStatus: "NOT_REQUIRED",
    classifierReadiness: "PARTIAL",
    eligibilityReadiness: "PARTIAL",
    calculationReadiness: "BLOCKED",
    uiReadiness: "PROTOTYPE_READY",
    activationStatus: "BLOCKED",
    blockingOQ: "OQ-V4-5",
    blockingReason: "Contribution rates not primary-source verified. V7-01..V7-08 checklist items unresolved.",
  },
  {
    code: "GCC-SA",
    name: "GCC — Saudi Arabia",
    jurisdiction: "AE-GPSSA",
    legalInstrument: "GCC Insurance Protection Extension Agreement",
    legalSourceStatus: "SOURCE_IDENTIFIED",
    interpretationStatus: "COUNSEL_REVIEW_REQUIRED",
    counselStatus: "COUNSEL_REVIEW_REQUIRED",
    classifierReadiness: "BLOCKED",
    eligibilityReadiness: "BLOCKED",
    calculationReadiness: "BLOCKED",
    uiReadiness: "PROTOTYPE_READY",
    activationStatus: "BLOCKED",
    blockingOQ: "OQ-V4-6",
    blockingReason: "External legal counsel required for all GCC national treatment.",
  },
  {
    code: "GCC-BH",
    name: "GCC — Bahrain",
    jurisdiction: "AE-GPSSA",
    legalInstrument: "GCC Insurance Protection Extension Agreement",
    legalSourceStatus: "SOURCE_IDENTIFIED",
    interpretationStatus: "COUNSEL_REVIEW_REQUIRED",
    counselStatus: "COUNSEL_REVIEW_REQUIRED",
    classifierReadiness: "BLOCKED",
    eligibilityReadiness: "BLOCKED",
    calculationReadiness: "BLOCKED",
    uiReadiness: "PROTOTYPE_READY",
    activationStatus: "BLOCKED",
    blockingOQ: "OQ-V4-6",
  },
  {
    code: "AE_ADPF",
    name: "Abu Dhabi — ADPF",
    jurisdiction: "AE-ADPF",
    legalInstrument: "Abu Dhabi Pension Law (evidence required)",
    legalSourceStatus: "EVIDENCE_REQUIRED",
    interpretationStatus: "OPEN",
    counselStatus: "NOT_REQUIRED",
    classifierReadiness: "BLOCKED",
    eligibilityReadiness: "BLOCKED",
    calculationReadiness: "BLOCKED",
    uiReadiness: "NOT_STARTED",
    activationStatus: "BLOCKED",
    blockingOQ: null,
  },
];

// ─── Rule Versions ────────────────────────────────────────────────────────────

export const ruleVersions = [
  {
    id: "rv-001",
    familyCode: "AE-GPSSA-LAW57-GOV-EE",
    regime: "UAE_LAW_57_2023_GOV",
    jurisdiction: "AE-GPSSA",
    label: "UAE Law 57/2023 — Gov — Employee",
    effectiveFrom: "2023-10-31",
    effectiveTo: null,
    rateValue: "11.00%",
    ceilingAmount: "AED 100,000/month",
    floorAmount: "AED 3,000/month",
    calculationBasis: "CONTRIBUTION_ACCOUNT_SALARY",
    evidenceRef: "Ministerial Decision No. 1/2024, Art. 11(2)(a)",
    status: "ACTIVE",
    approvedBy: "J. Smith",
    approvedAt: "2026-01-15",
  },
  {
    id: "rv-002",
    familyCode: "AE-GPSSA-LAW57-GOV-ER",
    regime: "UAE_LAW_57_2023_GOV",
    jurisdiction: "AE-GPSSA",
    label: "UAE Law 57/2023 — Gov — Employer",
    effectiveFrom: "2023-10-31",
    effectiveTo: null,
    rateValue: "15.00%",
    ceilingAmount: "AED 100,000/month",
    floorAmount: "AED 3,000/month",
    calculationBasis: "CONTRIBUTION_ACCOUNT_SALARY",
    evidenceRef: "Ministerial Decision No. 1/2024, Art. 11(2)(b)",
    status: "ACTIVE",
    approvedBy: "J. Smith",
    approvedAt: "2026-01-15",
  },
  {
    id: "rv-003",
    familyCode: "AE-GPSSA-LAW57-PRIV-EE",
    regime: "UAE_LAW_57_2023_PRIV",
    jurisdiction: "AE-GPSSA",
    label: "UAE Law 57/2023 — Private — Employee",
    effectiveFrom: "2023-10-31",
    effectiveTo: null,
    rateValue: "11.00%",
    ceilingAmount: "AED 70,000/month",
    floorAmount: "AED 3,000/month",
    calculationBasis: "CONTRIBUTION_ACCOUNT_SALARY",
    evidenceRef: "Ministerial Decision No. 1/2024, Art. 11(2)(c)",
    status: "ACTIVE",
    approvedBy: "J. Smith",
    approvedAt: "2026-01-15",
  },
  {
    id: "rv-004",
    familyCode: "IN-EPF-EE",
    regime: "IN_EPF",
    jurisdiction: "IN-EPFO",
    label: "India EPF — Employee",
    effectiveFrom: "2014-09-01",
    effectiveTo: null,
    rateValue: "12.00%",
    ceilingAmount: "INR 15,000/month (wage ceiling)",
    floorAmount: null,
    calculationBasis: "BASIC_WAGES_DA",
    evidenceRef: "EPF & MP Act 1952, Section 6",
    status: "ACTIVE",
    approvedBy: "M. Patel",
    approvedAt: "2025-11-01",
  },
  {
    id: "rv-005",
    familyCode: "AE-GPSSA-LAW7-EE",
    regime: "UAE_LAW_7_1999",
    jurisdiction: "AE-GPSSA",
    label: "UAE Law 7/1999 — Employee [BLOCKED]",
    effectiveFrom: null,
    effectiveTo: null,
    rateValue: "PENDING LEGAL VERIFICATION",
    ceilingAmount: "PENDING LEGAL VERIFICATION",
    floorAmount: "PENDING LEGAL VERIFICATION",
    calculationBasis: "PENDING LEGAL VERIFICATION",
    evidenceRef: "Not available — primary source not verified",
    status: "BLOCKED",
    blockingOQ: "OQ-V4-5",
    blockingReason: "Contribution rates for Federal Law No. 7 of 1999 have not been verified against primary-source text. V7-01 through V7-08 checklist items unresolved.",
    approvedBy: null,
    approvedAt: null,
  },
  {
    id: "rv-006",
    familyCode: "AE-GPSSA-LAW7-ER",
    regime: "UAE_LAW_7_1999",
    jurisdiction: "AE-GPSSA",
    label: "UAE Law 7/1999 — Employer [BLOCKED]",
    effectiveFrom: null,
    effectiveTo: null,
    rateValue: "PENDING LEGAL VERIFICATION",
    ceilingAmount: "PENDING LEGAL VERIFICATION",
    floorAmount: "PENDING LEGAL VERIFICATION",
    calculationBasis: "PENDING LEGAL VERIFICATION",
    evidenceRef: "Not available — primary source not verified",
    status: "BLOCKED",
    blockingOQ: "OQ-V4-5",
    blockingReason: "Contribution rates for Federal Law No. 7 of 1999 have not been verified against primary-source text.",
    approvedBy: null,
    approvedAt: null,
  },
  {
    id: "rv-007",
    familyCode: "AE-GPSSA-GCC-SA",
    regime: "GCC-SA",
    jurisdiction: "AE-GPSSA",
    label: "GCC — Saudi Arabia [BLOCKED]",
    effectiveFrom: null,
    effectiveTo: null,
    rateValue: "PENDING LEGAL VERIFICATION",
    ceilingAmount: "PENDING LEGAL VERIFICATION",
    calculationBasis: "PENDING LEGAL VERIFICATION",
    evidenceRef: "External counsel required — not available",
    status: "BLOCKED",
    blockingOQ: "OQ-V4-6",
    blockingReason: "External legal counsel required before any GCC national contribution configuration can proceed.",
    approvedBy: null,
    approvedAt: null,
  },
];

// ─── Persons (mock classification states) ────────────────────────────────────

export const persons = [
  {
    id: "p-001",
    name: "Ahmed Al-Rashidi",
    employeeId: "EMP-1001",
    nationality: "AE",
    workCountry: "AE",
    workEmirate: "Dubai",
    sector: "GOVERNMENT",
    employmentStart: "2024-03-01",
    classificationStatus: "CLASSIFIED",
    regime: "UAE_LAW_57_2023_GOV",
    article2Clause: "Art. 2(1)(a)",
    eligibilityStatus: "EFFECTIVE",
    cohort: "LAW57_GOV",
  },
  {
    id: "p-002",
    name: "Fatima Al-Mansoori",
    employeeId: "EMP-1002",
    nationality: "AE",
    workCountry: "AE",
    workEmirate: "Abu Dhabi",
    sector: "PRIVATE",
    employmentStart: "2018-06-01",
    classificationStatus: "CLASSIFIED",
    regime: "UAE_LAW_7_1999",
    article2Clause: "Art. 2(2)(a) — legacy joiner",
    eligibilityStatus: "LEGAL_REVIEW_REQUIRED",
    cohort: "LAW7_LEGACY",
    nonSuccessState: "LEGAL_BASIS_PENDING",
    nonSuccessReason: "Law 7/1999 regime determined. Contribution basis and rates pending primary-source verification (OQ-V4-5). Obligation is NOT discharged.",
    blockingOQ: "OQ-V4-5",
  },
  {
    id: "p-003",
    name: "Khalid Al-Dosari",
    employeeId: "EMP-1003",
    nationality: "SA",
    workCountry: "AE",
    workEmirate: "Dubai",
    sector: "PRIVATE",
    employmentStart: "2025-01-15",
    classificationStatus: "CLASSIFIED",
    regime: "GCC-SA",
    article2Clause: "GCC national — counsel track",
    eligibilityStatus: "COUNSEL_REVIEW_REQUIRED",
    cohort: null,
    nonSuccessState: "COUNSEL_REVIEW_REQUIRED",
    nonSuccessReason: "GCC national (Saudi) — external legal counsel required to determine applicable pension treatment. No contribution may be calculated until OQ-V4-6 is resolved.",
    blockingOQ: "OQ-V4-6",
  },
  {
    id: "p-004",
    name: "Priya Nair",
    employeeId: "EMP-1004",
    nationality: "IN",
    workCountry: "IN",
    workEmirate: null,
    sector: "PRIVATE",
    employmentStart: "2023-08-01",
    classificationStatus: "CLASSIFIED",
    regime: "IN_EPF",
    article2Clause: "EPF Act 1952, S.2(b) — covered establishment",
    eligibilityStatus: "EFFECTIVE",
    cohort: "IN_EPF_COVERED",
  },
  {
    id: "p-005",
    name: "Omar Al-Shamsi",
    employeeId: "EMP-1005",
    nationality: "AE",
    workCountry: "AE",
    workEmirate: "Sharjah",
    sector: "GOVERNMENT",
    employmentStart: "2016-04-01",
    classificationStatus: "CLASSIFICATION_AMBIGUOUS",
    regime: null,
    article2Clause: null,
    eligibilityStatus: "AMBIGUOUS",
    cohort: null,
    nonSuccessState: "CLASSIFICATION_AMBIGUOUS",
    nonSuccessReason: "Conflicting inputs: employment start date (2016) and reported prior GPSSA coverage (YES under Law 7/1999, YES under Law 57/2023) cannot be deterministically resolved. Analyst investigation required.",
    conflictDetails: "Prior Law 7/1999 coverage = YES contradicts first-time joiner = YES",
  },
  {
    id: "p-006",
    name: "Sarah Thompson",
    employeeId: "EMP-1006",
    nationality: "GB",
    workCountry: "AE",
    workEmirate: "Dubai",
    sector: "PRIVATE",
    employmentStart: "2022-11-01",
    classificationStatus: "CLASSIFIED",
    regime: "UAE_EXPAT",
    article2Clause: "N/A — expatriate",
    eligibilityStatus: "NO_APPLICABLE_REGIME",
    cohort: null,
    nonSuccessState: "NO_APPLICABLE_REGIME",
    nonSuccessReason: "No GPSSA obligation applies. Expatriate worker — no UAE statutory pension contribution required.",
  },
];

// ─── Eligibility Determinations ───────────────────────────────────────────────

export const eligibilityDeterminations = [
  {
    id: "eld-001",
    personId: "p-001",
    personName: "Ahmed Al-Rashidi",
    regime: "UAE_LAW_57_2023_GOV",
    status: "EFFECTIVE",
    eligibilityResult: "ELIGIBLE",
    reasonCode: "AGE_IN_RANGE + MEDICAL_FIT",
    effectiveDate: "2024-03-01",
    determinedBy: "J. Smith",
    determinedAt: "2024-02-28",
    evidenceRef: "ev-001",
    lifecycleState: "EFFECTIVE",
  },
  {
    id: "eld-002",
    personId: "p-002",
    personName: "Fatima Al-Mansoori",
    regime: "UAE_LAW_7_1999",
    status: "LEGAL_REVIEW_REQUIRED",
    eligibilityResult: "PENDING",
    reasonCode: "LEGAL_BASIS_PENDING",
    effectiveDate: null,
    determinedBy: null,
    determinedAt: "2026-02-15",
    evidenceRef: null,
    lifecycleState: "CLASSIFIED",
    nonSuccessState: "LEGAL_BASIS_PENDING",
    blockingOQ: "OQ-V4-5",
  },
  {
    id: "eld-003",
    personId: "p-003",
    personName: "Khalid Al-Dosari",
    regime: "GCC-SA",
    status: "COUNSEL_REVIEW_REQUIRED",
    eligibilityResult: "PENDING",
    reasonCode: "COUNSEL_REVIEW_REQUIRED",
    effectiveDate: null,
    determinedBy: null,
    determinedAt: "2026-02-10",
    evidenceRef: null,
    lifecycleState: "CLASSIFIED",
    nonSuccessState: "COUNSEL_REVIEW_REQUIRED",
    blockingOQ: "OQ-V4-6",
  },
  {
    id: "eld-004",
    personId: "p-004",
    personName: "Priya Nair",
    regime: "IN_EPF",
    status: "EFFECTIVE",
    eligibilityResult: "ELIGIBLE",
    reasonCode: "COVERED_ESTABLISHMENT + WAGE_THRESHOLD",
    effectiveDate: "2023-08-01",
    determinedBy: "M. Patel",
    determinedAt: "2023-07-30",
    evidenceRef: "ev-004",
    lifecycleState: "EFFECTIVE",
  },
  {
    id: "eld-005",
    personId: "p-005",
    personName: "Omar Al-Shamsi",
    regime: null,
    status: "AMBIGUOUS",
    eligibilityResult: "PENDING",
    reasonCode: "CLASSIFICATION_AMBIGUOUS",
    effectiveDate: null,
    determinedBy: null,
    determinedAt: "2026-03-01",
    evidenceRef: null,
    lifecycleState: "PENDING_CONTEXT",
    nonSuccessState: "CLASSIFICATION_AMBIGUOUS",
    blockingOQ: null,
  },
  {
    id: "eld-006",
    personId: "p-001",
    personName: "Ahmed Al-Rashidi",
    regime: "UAE_LAW_57_2023_GOV",
    status: "SUPERSEDED",
    eligibilityResult: "ELIGIBLE",
    reasonCode: "PRIOR_DRAFT_SUPERSEDED",
    effectiveDate: null,
    determinedBy: "J. Smith",
    determinedAt: "2024-01-15",
    evidenceRef: "ev-001",
    lifecycleState: "SUPERSEDED",
    supersededById: "eld-001",
  },
];

// ─── Legal Evidence Records ───────────────────────────────────────────────────

export const evidenceRecords = [
  {
    id: "ev-001",
    instrumentTitle: "Ministerial Decision No. (1) of 2024",
    articleSection: "Articles 7–12 — Contribution basis, rates, ceiling",
    sourceAuthority: "UAE Ministry of Human Resources and Emiratisation",
    sourceType: "MINISTERIAL_DECISION",
    jurisdiction: "AE-GPSSA",
    regime: "UAE_LAW_57_2023_GOV",
    publicationDate: "2024-01-01",
    sourceStatus: "PRIMARY_SOURCE_VERIFIED",
    verificationStatus: "VERIFIED",
    interpretationStatus: "APPROVED_FOR_CONFIGURATION",
    counselStatus: "NOT_REQUIRED",
    verifiedBy: "Legal Team",
    verifiedAt: "2025-09-01",
    linkedRuleVersions: ["rv-001", "rv-002", "rv-003"],
    notes: "Primary source confirmed via UAE official government portal.",
  },
  {
    id: "ev-002",
    instrumentTitle: "Federal Law No. 57 of 2023",
    articleSection: "Article 2 — Coverage scope and regime assignment",
    sourceAuthority: "UAE Federal Government",
    sourceType: "PRIMARY_STATUTE",
    jurisdiction: "AE-GPSSA",
    regime: "UAE_LAW_57_2023_GOV",
    publicationDate: "2023-10-31",
    sourceStatus: "PRIMARY_SOURCE_VERIFIED",
    verificationStatus: "VERIFIED",
    interpretationStatus: "APPROVED_FOR_CONFIGURATION",
    counselStatus: "NOT_REQUIRED",
    verifiedBy: "Legal Team",
    verifiedAt: "2025-08-15",
    linkedRuleVersions: ["rv-001", "rv-002", "rv-003"],
    notes: "Federal Law confirmed against UAE official gazette.",
  },
  {
    id: "ev-003",
    instrumentTitle: "Federal Law No. 7 of 1999",
    articleSection: "Multiple articles — rates and coverage unverified",
    sourceAuthority: "UAE Federal Government",
    sourceType: "PRIMARY_STATUTE",
    jurisdiction: "AE-GPSSA",
    regime: "UAE_LAW_7_1999",
    publicationDate: "1999-01-01",
    sourceStatus: "SOURCE_IDENTIFIED",
    verificationStatus: "UNVERIFIED",
    interpretationStatus: "LEGAL_INTERPRETATION_REQUIRED",
    counselStatus: "NOT_REQUIRED",
    verifiedBy: null,
    verifiedAt: null,
    linkedRuleVersions: ["rv-005", "rv-006"],
    notes: "Primary text located — contribution rates and basis require article-level verification (V7-01..V7-08). See OQ-V4-5.",
    blockingOQ: "OQ-V4-5",
  },
  {
    id: "ev-004",
    instrumentTitle: "EPF & Miscellaneous Provisions Act 1952",
    articleSection: "Section 6 — Contribution; Paragraph 2 of Schedule IV",
    sourceAuthority: "Government of India, Ministry of Labour",
    sourceType: "PRIMARY_STATUTE",
    jurisdiction: "IN-EPFO",
    regime: "IN_EPF",
    publicationDate: "1952-03-04",
    sourceStatus: "PRIMARY_SOURCE_VERIFIED",
    verificationStatus: "VERIFIED",
    interpretationStatus: "APPROVED_FOR_CONFIGURATION",
    counselStatus: "NOT_REQUIRED",
    verifiedBy: "M. Patel",
    verifiedAt: "2025-10-01",
    linkedRuleVersions: ["rv-004"],
    notes: "Verified against India Government Gazette. Wage ceiling INR 15,000 confirmed per EPFO circular.",
  },
  {
    id: "ev-005",
    instrumentTitle: "GCC Insurance Protection Extension Agreement",
    articleSection: "Articles pending counsel identification",
    sourceAuthority: "GCC Secretariat",
    sourceType: "BILATERAL_AGREEMENT",
    jurisdiction: "AE-GPSSA",
    regime: "GCC-SA",
    publicationDate: null,
    sourceStatus: "SOURCE_IDENTIFIED",
    verificationStatus: "UNVERIFIED",
    interpretationStatus: "COUNSEL_REVIEW_REQUIRED",
    counselStatus: "COUNSEL_REVIEW_REQUIRED",
    verifiedBy: null,
    verifiedAt: null,
    linkedRuleVersions: ["rv-007"],
    notes: "Agreement identified. External legal counsel required to determine applicable treatment for each GCC nationality. See OQ-V4-6.",
    blockingOQ: "OQ-V4-6",
  },
];

// ─── Audit Events ─────────────────────────────────────────────────────────────

export const auditEvents = [
  {
    id: "ae-001",
    eventType: "CLASSIFICATION_COMPLETE",
    personName: "Ahmed Al-Rashidi",
    personId: "p-001",
    jurisdiction: "AE-GPSSA",
    regime: "UAE_LAW_57_2023_GOV",
    status: "EFFECTIVE",
    resultState: null,
    actor: "J. Smith",
    timestamp: "2026-03-01T09:14:32Z",
    determinationId: "eld-001",
    ruleVersionId: "rv-001",
    evidenceRef: "ev-001",
    detail: "Article 2(1)(a) — UAE national, government sector, post-Law 57 joiner",
  },
  {
    id: "ae-002",
    eventType: "ELIGIBILITY_TRANSITION",
    personName: "Fatima Al-Mansoori",
    personId: "p-002",
    jurisdiction: "AE-GPSSA",
    regime: "UAE_LAW_7_1999",
    status: "LEGAL_BASIS_PENDING",
    resultState: "LEGAL_BASIS_PENDING",
    actor: "System",
    timestamp: "2026-02-20T14:32:10Z",
    determinationId: "eld-002",
    ruleVersionId: "rv-005",
    evidenceRef: null,
    detail: "UAE_LAW_7_1999 rule version BLOCKED. Contribution suspended — obligation NOT discharged. See OQ-V4-5.",
  },
  {
    id: "ae-003",
    eventType: "CLASSIFICATION_COMPLETE",
    personName: "Khalid Al-Dosari",
    personId: "p-003",
    jurisdiction: "AE-GPSSA",
    regime: "GCC-SA",
    status: "COUNSEL_REVIEW_REQUIRED",
    resultState: "COUNSEL_REVIEW_REQUIRED",
    actor: "System",
    timestamp: "2026-02-10T08:55:12Z",
    determinationId: "eld-003",
    ruleVersionId: null,
    evidenceRef: null,
    detail: "GCC national (SA) — counsel review track initiated. No contribution may be calculated. See OQ-V4-6.",
  },
  {
    id: "ae-004",
    eventType: "CALCULATION_FINALIZED",
    personName: "Priya Nair",
    personId: "p-004",
    jurisdiction: "IN-EPFO",
    regime: "IN_EPF",
    status: "EFFECTIVE",
    resultState: null,
    actor: "PayrollEngine",
    timestamp: "2026-01-15T10:00:00Z",
    determinationId: "eld-004",
    ruleVersionId: "rv-004",
    evidenceRef: "ev-004",
    detail: "EPF employee contribution: INR 1,440. EPF employer contribution (EPF): INR 550. EPS employer: INR 1,250.",
  },
  {
    id: "ae-005",
    eventType: "CLASSIFICATION_AMBIGUOUS",
    personName: "Omar Al-Shamsi",
    personId: "p-005",
    jurisdiction: "AE-GPSSA",
    regime: null,
    status: "CLASSIFICATION_AMBIGUOUS",
    resultState: "CLASSIFICATION_AMBIGUOUS",
    actor: "System",
    timestamp: "2026-03-01T11:20:00Z",
    determinationId: "eld-005",
    ruleVersionId: null,
    evidenceRef: null,
    detail: "Conflicting Article 2 inputs. Prior Law 7/1999 coverage contradicts first-time joiner flag. Analyst investigation required.",
  },
  {
    id: "ae-006",
    eventType: "DETERMINATION_SUPERSEDED",
    personName: "Ahmed Al-Rashidi",
    personId: "p-001",
    jurisdiction: "AE-GPSSA",
    regime: "UAE_LAW_57_2023_GOV",
    status: "SUPERSEDED",
    resultState: "SUPERSEDED",
    actor: "J. Smith",
    timestamp: "2024-02-28T15:00:00Z",
    determinationId: "eld-006",
    ruleVersionId: null,
    evidenceRef: "ev-001",
    detail: "Draft determination superseded by approved determination eld-001.",
  },
];

// ─── Open Questions ────────────────────────────────────────────────────────────

export const openQuestions = [
  {
    id: "OQ-V4-1",
    category: "ARB",
    jurisdiction: "All",
    title: "Regime assignment data model approval",
    description: "ARB must approve the PersonRegimeAssignment entity and Article 2 classification logic before any W11-L-IMPL schema work.",
    owner: "Architecture / ARB",
    status: "OPEN",
    blockerType: "ARB_DECISION",
    dependency: "TG-V4-1, TG-V4-2",
    evidenceRequired: "ARB written disposition",
    nextAction: "Submit v0.4 package for ARB decision",
    priority: "P0",
  },
  {
    id: "OQ-V4-2",
    category: "Legal",
    jurisdiction: "AE-GPSSA",
    title: "Article 2(1)(c) transitional path interpretation",
    description: "Legal interpretation required for Article 2(1)(c) transitional cases — employees who joined before Law 57 enactment.",
    owner: "Legal + Architecture",
    status: "LEGAL_INTERPRETATION_REQUIRED",
    blockerType: "LEGAL_INTERPRETATION",
    dependency: "OQ-V4-1",
    evidenceRequired: "Legal team interpretation of Art. 2(1)(c)",
    nextAction: "Legal team to provide written interpretation",
    priority: "P1",
  },
  {
    id: "OQ-V4-3",
    category: "Legal",
    jurisdiction: "AE-GPSSA",
    title: "Article 2(2)(a) legacy cohort determination",
    description: "GPSSA Council confirmation required for the criteria determining Law 7/1999 legacy coverage.",
    owner: "Legal + GPSSA",
    status: "OPEN",
    blockerType: "EXTERNAL_LEGAL",
    dependency: "OQ-V4-5",
    evidenceRequired: "GPSSA Council written clarification",
    nextAction: "Legal to initiate GPSSA Council inquiry",
    priority: "P0",
  },
  {
    id: "OQ-V4-4",
    category: "Legal",
    jurisdiction: "AE-GPSSA",
    title: "Article 2(1)(f) ministerial exemption",
    description: "GPSSA Council confirmation required for ministerial-level exemption from standard GPSSA classification.",
    owner: "Legal + GPSSA",
    status: "OPEN",
    blockerType: "EXTERNAL_LEGAL",
    dependency: null,
    evidenceRequired: "GPSSA Council clarification on Art. 2(1)(f)",
    nextAction: "Pending GPSSA Council consultation",
    priority: "P2",
  },
  {
    id: "OQ-V4-5",
    category: "Statutory Analyst",
    jurisdiction: "AE-GPSSA",
    title: "Law 7/1999 contribution rates primary-source verification",
    description: "Contribution rates (employee, employer, government) and salary basis for Federal Law No. 7 of 1999 have not been verified against primary-source text. V7-01 through V7-08 checklist items unresolved.",
    owner: "Statutory Analyst",
    status: "LEGAL_INTERPRETATION_REQUIRED",
    blockerType: "PRIMARY_SOURCE_UNVERIFIED",
    dependency: null,
    evidenceRequired: "V7-01..V7-08 evidence matrix with article references and primary-source links",
    nextAction: "Statutory Analyst to locate and verify primary text of Federal Law No. 7/1999",
    priority: "P0",
    blockedEntities: ["rv-005", "rv-006", "eld-002"],
    checklistProgress: "0 of 15 items verified",
  },
  {
    id: "OQ-V4-6",
    category: "Counsel",
    jurisdiction: "AE-GPSSA",
    title: "GCC national pension treatment in UAE employment",
    description: "External legal counsel required to determine applicable pension treatment for GCC nationals (SA, BH, KW, QA, OM) employed in UAE. Covers competent authority, salary base, rates, employer obligation, and effective-date rules.",
    owner: "External Legal Counsel",
    status: "COUNSEL_REVIEW_REQUIRED",
    blockerType: "COUNSEL_REQUIRED",
    dependency: null,
    evidenceRequired: "Written responses to GCC questionnaire (Q1–Q10 per nationality)",
    nextAction: "Issue bounded GCC legal questionnaire to external counsel (see W11_L_V04_REENTRY_PACKAGE.md §4)",
    priority: "P0",
    blockedEntities: ["rv-007", "eld-003"],
    nationalities: ["SA", "BH", "KW", "QA", "OM"],
  },
  {
    id: "OQ-V4-7",
    category: "Legal",
    jurisdiction: "AE-GPSSA",
    title: "Medical fitness determination for pension eligibility",
    description: "GPSSA confirmation required for medical fitness criteria applicable at pension eligibility determination stage.",
    owner: "Legal + GPSSA",
    status: "OPEN",
    blockerType: "EXTERNAL_LEGAL",
    dependency: null,
    evidenceRequired: "GPSSA medical fitness criteria",
    nextAction: "Legal to request clarification from GPSSA",
    priority: "P2",
  },
];

// ─── Transition Gates ─────────────────────────────────────────────────────────

export const transitionGates = [
  {
    id: "TG-V4-1",
    title: "Dual-Regime Routing Model",
    criterion: "PersonRegimeAssignment data model and Article 2 classification logic approved by ARB",
    artifactsProduced: "WS-1 §3: Decision tree, state machine, 16-route table, non-success states",
    artifactStatus: "COMPLETE",
    gateStatus: "OPEN",
    gateStatusDetail: "ARB decision pending",
    blockingOQ: "OQ-V4-1",
    wave: "Wave 1",
  },
  {
    id: "TG-V4-2",
    title: "Person-Level Eligibility Lifecycle",
    criterion: "StatutoryEligibilityDetermination entity and lifecycle state machine approved by ARB",
    artifactsProduced: "WS-2 §4: 19-field entity, lifecycle state machine, 4 exception states",
    artifactStatus: "COMPLETE",
    gateStatus: "OPEN",
    gateStatusDetail: "ARB decision pending",
    blockingOQ: "OQ-V4-1",
    wave: "Wave 1",
  },
  {
    id: "TG-V4-3",
    title: "Law 7/1999 Primary-Source Verification",
    criterion: "V7-01..V7-08 + V7-13 reach PRIMARY_SOURCE_VERIFIED; OQ-V4-5 advances to P0-C = VERIFIED",
    artifactsProduced: "WS-3 §5: 15-item verification checklist, engineering scaffold, unblocking path",
    artifactStatus: "COMPLETE",
    gateStatus: "EXTERNALLY_BLOCKED",
    gateStatusDetail: "Blocked on OQ-V4-5 — Statutory Analyst must verify primary source",
    blockingOQ: "OQ-V4-5",
    wave: "Wave 2",
    checklistProgress: "0 / 15 items verified",
  },
  {
    id: "TG-V4-4",
    title: "GCC Counsel Track",
    criterion: "OQ-V4-6 reaches P0-C = INTERPRETATION_PENDING; competent authority and rate source populated for at least one GCC nationality",
    artifactsProduced: "WS-4 §6: GCC routing model, Pattern B, REGIME_PENDING_COUNSEL flow",
    artifactStatus: "COMPLETE",
    gateStatus: "EXTERNALLY_BLOCKED",
    gateStatusDetail: "Blocked on OQ-V4-6 — external counsel required",
    blockingOQ: "OQ-V4-6",
    wave: "Wave 3",
  },
  {
    id: "TG-V4-5",
    title: "Evidence Provenance Model",
    criterion: "LegalEvidenceReference immutable field list and DB-level INSERT-only trigger requirement confirmed by ARB",
    artifactsProduced: "WS-2 §4.2 + IMPL-A + ADR D-L3: evidence reference entity, immutable field list",
    artifactStatus: "COMPLETE",
    gateStatus: "OPEN",
    gateStatusDetail: "ARB decision pending",
    blockingOQ: null,
    wave: "Wave 1",
  },
  {
    id: "TG-V4-6",
    title: "Implementation Blueprint + UI/UX",
    criterion: "IMPL-A through IMPL-D blueprint and WS-5D UI/UX design reviewed and approved by ARB",
    artifactsProduced: "W11_L_V04_IMPLEMENTATION_READINESS.md + W11_L_V04_UI_UX_DESIGN.md (8 screens)",
    artifactStatus: "COMPLETE",
    gateStatus: "OPEN",
    gateStatusDetail: "ARB decision pending",
    blockingOQ: null,
    wave: "Wave 1",
  },
];

// ─── Readiness Matrix ─────────────────────────────────────────────────────────

export const readinessMatrix = [
  {
    jurisdiction: "IN-EPFO",
    jurisdictionName: "India — EPFO",
    regime: "IN_EPF",
    regimeName: "India EPF",
    legalSource: "PRIMARY_SOURCE_VERIFIED",
    interpretation: "APPROVED_FOR_CONFIGURATION",
    counsel: "NOT_REQUIRED",
    classifier: "DESIGN_READY",
    eligibility: "DESIGN_READY",
    calculationModel: "DESIGN_READY",
    uiReadiness: "PROTOTYPE_READY",
    activationStatus: "PENDING_ARB",
  },
  {
    jurisdiction: "IN-EPFO",
    jurisdictionName: "India — EPFO",
    regime: "IN_ESI",
    regimeName: "India ESI",
    legalSource: "PRIMARY_SOURCE_VERIFIED",
    interpretation: "APPROVED_FOR_CONFIGURATION",
    counsel: "NOT_REQUIRED",
    classifier: "DESIGN_READY",
    eligibility: "DESIGN_READY",
    calculationModel: "DESIGN_READY",
    uiReadiness: "PROTOTYPE_READY",
    activationStatus: "PENDING_ARB",
    note: "GAP-05 caveat",
  },
  {
    jurisdiction: "AE-GPSSA",
    jurisdictionName: "UAE Federal — GPSSA",
    regime: "UAE_LAW_57_2023_GOV",
    regimeName: "UAE Law 57/2023 (Government)",
    legalSource: "PRIMARY_SOURCE_VERIFIED",
    interpretation: "APPROVED_FOR_CONFIGURATION",
    counsel: "NOT_REQUIRED",
    classifier: "DESIGN_READY",
    eligibility: "DESIGN_READY",
    calculationModel: "DESIGN_READY",
    uiReadiness: "PROTOTYPE_READY",
    activationStatus: "PENDING_ARB",
  },
  {
    jurisdiction: "AE-GPSSA",
    jurisdictionName: "UAE Federal — GPSSA",
    regime: "UAE_LAW_57_2023_PRIV",
    regimeName: "UAE Law 57/2023 (Private)",
    legalSource: "PRIMARY_SOURCE_VERIFIED",
    interpretation: "APPROVED_FOR_CONFIGURATION",
    counsel: "NOT_REQUIRED",
    classifier: "DESIGN_READY",
    eligibility: "DESIGN_READY",
    calculationModel: "DESIGN_READY",
    uiReadiness: "PROTOTYPE_READY",
    activationStatus: "PENDING_ARB",
  },
  {
    jurisdiction: "AE-GPSSA",
    jurisdictionName: "UAE Federal — GPSSA",
    regime: "UAE_LAW_7_1999",
    regimeName: "UAE Law 7/1999 (Legacy)",
    legalSource: "SOURCE_IDENTIFIED",
    interpretation: "LEGAL_INTERPRETATION_REQUIRED",
    counsel: "NOT_REQUIRED",
    classifier: "PARTIAL",
    eligibility: "PARTIAL",
    calculationModel: "BLOCKED",
    uiReadiness: "PROTOTYPE_READY",
    activationStatus: "BLOCKED",
    blockingOQ: "OQ-V4-5",
  },
  {
    jurisdiction: "AE-GPSSA",
    jurisdictionName: "UAE Federal — GPSSA",
    regime: "GCC-SA",
    regimeName: "GCC — Saudi Arabia",
    legalSource: "SOURCE_IDENTIFIED",
    interpretation: "COUNSEL_REVIEW_REQUIRED",
    counsel: "COUNSEL_REVIEW_REQUIRED",
    classifier: "BLOCKED",
    eligibility: "BLOCKED",
    calculationModel: "BLOCKED",
    uiReadiness: "PROTOTYPE_READY",
    activationStatus: "BLOCKED",
    blockingOQ: "OQ-V4-6",
  },
  {
    jurisdiction: "AE-GPSSA",
    jurisdictionName: "UAE Federal — GPSSA",
    regime: "GCC-BH",
    regimeName: "GCC — Bahrain",
    legalSource: "SOURCE_IDENTIFIED",
    interpretation: "COUNSEL_REVIEW_REQUIRED",
    counsel: "COUNSEL_REVIEW_REQUIRED",
    classifier: "BLOCKED",
    eligibility: "BLOCKED",
    calculationModel: "BLOCKED",
    uiReadiness: "PROTOTYPE_READY",
    activationStatus: "BLOCKED",
    blockingOQ: "OQ-V4-6",
  },
  {
    jurisdiction: "AE-ADPF",
    jurisdictionName: "UAE — Abu Dhabi (ADPF)",
    regime: "AE_ADPF",
    regimeName: "Abu Dhabi — ADPF",
    legalSource: "EVIDENCE_REQUIRED",
    interpretation: "OPEN",
    counsel: "NOT_REQUIRED",
    classifier: "BLOCKED",
    eligibility: "BLOCKED",
    calculationModel: "BLOCKED",
    uiReadiness: "NOT_STARTED",
    activationStatus: "BLOCKED",
    blockingOQ: null,
  },
  {
    jurisdiction: "AE-SHARJAH",
    jurisdictionName: "UAE — Sharjah Government",
    regime: "AE_SHARJAH",
    regimeName: "Sharjah Government PA",
    legalSource: "EVIDENCE_REQUIRED",
    interpretation: "OPEN",
    counsel: "NOT_REQUIRED",
    classifier: "BLOCKED",
    eligibility: "BLOCKED",
    calculationModel: "BLOCKED",
    uiReadiness: "NOT_STARTED",
    activationStatus: "BLOCKED",
    blockingOQ: null,
  },
];
